import React from 'react';
import LabelledTickbox from '../LabelledTickbox';
import { gridBorder } from './styles';
import { border } from '../styles';

const SelectHeaderCell = ({
    headerName,
    colSpan,
    width,
    gap,
    size,
    def,
    disabled,
    areAllSelected = false,
    onTick,
    scrollPxH,
    scrollPxV,
    isColSticky,
    style,
    reverseElements,
    tickboxStyle,
    tickboxContainerStyle,
    ...props
}) => {
    return (
        <th
            {...props}
            colSpan={colSpan}
            width={width}
            style={{
                ...gridBorder,
                backgroundColor: '#FFFFFF',
                position: 'relative',
                boxSizing: 'border-box',
                bottom: scrollPxV,
                borderTop: border,
                borderLeftWidth: 0,
                zIndex: 200,
                right: isColSticky ? undefined : scrollPxH,
                padding: '0 10px',
                ...style
            }}
        >
            <LabelledTickbox
                reverseElements={reverseElements}
                gap={gap}
                size={size}
                title={`${headerName}`} // Ensure title is string
                value={areAllSelected}
                onClick={onTick}
                containerStyle={{
                    justifyContent: 'space-between',
                    width: '100%',
                    ...tickboxContainerStyle
                }}
                style={tickboxStyle}
            />
        </th>
    );
};

export default SelectHeaderCell;
